import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, Stack, Typography, Button } from '@mui/material';
import feedbackService from '../services/feedbackService';

function FeedbackDetailPage() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(null);

    const load = async () => {
        setLoading(true);
        try {
            const res = await feedbackService.get(id);
            setItem(res.data?.data || null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

    if (!item && !loading) {
        return <Typography variant="body2" color="text.secondary">Feedback not found.</Typography>;
    }

    return (
        <Box>
            <Paper sx={{ p: 2 }}>
                <Stack spacing={1}>
                    <Typography variant="h6">{item?.title || 'Loading...'}</Typography>
                    <Typography variant="body2" color="text.secondary">{item?.category} • {String(item?.status || '').replace(/_/g, ' ')}</Typography>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>{item?.description}</Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Button size="small" variant={item?.hasVoted ? 'contained' : 'outlined'} onClick={async () => {
                            const res = await feedbackService.toggleVote(id);
                            setItem((prev) => prev ? { ...prev, hasVoted: res.data?.data?.hasVoted, voteCount: res.data?.data?.voteCount } : prev);
                        }}>{item?.voteCount ?? 0} Vote{(item?.voteCount ?? 0) === 1 ? '' : 's'}</Button>
                        <Typography variant="caption" color="text.secondary">Created {item?.createdAt ? new Date(item.createdAt).toLocaleString() : ''}</Typography>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
}

export default FeedbackDetailPage;


